<template>
  <form @submit.prevent="handleSubmit">
    <div class="form-group">
      <div
        class="alert text-left formatted-text"
        :class="{
          'alert-danger': message.error,
          'alert-success': !message.error,
        }"
        role="alert"
        v-show="message.display"
      >
        {{ this.message.content }}
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group row">
          <label for="title" class="col-md-4">Titre:</label>
          <input
            v-model="link.title"
            type="text"
            class="form-control col-md-8"
            :class="{ 'is-invalid': submitted && !link.title }"
            id="title"
            placeholder="Titre"
            name="title"
          />
        </div>

        <div class="form-group row">
          <label for="en_title" class="col-md-4">Titre (version anglaise):</label>
          <input
            v-model="link.title_en"
            type="text"
            class="form-control col-md-8"
            :class="{ 'is-invalid': submitted && !link.title_en }"
            id="title_en"
            placeholder="Titre version anglaise"
            name="title_en"
          />
        </div>

        <div class="form-group row">
          <label for="url" class="col-md-4">URL:</label>
          <input
            v-model="link.url"
            type="text"
            class="form-control col-md-8"
            :class="{ 'is-invalid': submitted && !link.url }"
            id="url"
            placeholder="Url"
            name="url"
          />
        </div>

        <div class="form-group row">
          <label for="rank" class="col-md-4">Rang:</label>
          <input
            v-model="link.rank"
            type="text"
            class="form-control col-md-8"
            :class="{ 'is-invalid': submitted && !link.rank }"
            id="rank"
            placeholder="Rang"
            name="rank"
          />
        </div>


        <div class="form-group row">
          <label for="media" class="col-md-4">Logo:</label>
          <input
            @change="onFileChange($event)"
            type="file"
            accept="image/png, image/jpeg, image/jpg"
            class="form-control col-md-8"
            :class="{ 'is-invalid': submitted && !link.photo }"
            id="photo"
            placeholder="Logo"
            name="media"
          />
        </div>
        <div class="form-group row">
          <label class="col-md-2"></label>
          <img id="imageDisplay" class="col-md-6" />
        </div>

        <div class="form-group row">
          <label class="col-md-2"></label>
          <div class="col-md-8">
            <button type="submit" class="btn btn-primary">Enrégister</button>
            <router-link
              class="btn btn-dark action-btn-cancel"
              :to="{ name: 'links' }"
            >
              Retourner
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
// import { mapGetters } from "vuex";
import { UPDATE_LINK } from "@/store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";
import { SUCCESS_MESSAGE } from "@/helpers/messages";


export default {
  name: "LinkEditForm",
  components: {
  },
  data() {
    return {
      link: {
        title: "",
        url: "",
        title_en: "",
        photo: "",
        rank: "",
      },
      submitted: false,
      message: {
        error: false,
        display: false,
        content: "",
      },
      errors: {},
    };
  },
  async mounted() {
    this.link = this.$store.state.link.link;
    if (this.link.photo) {
      document.querySelector("#imageDisplay").src = this.link.photo;
    }
  },

  methods: {
    handleSubmit() {
      // affichage réinitialisé
      this.message.display = false;

      this.submitted = true;

      const { title, url, title_en, rank, photo} = this.link;
      if (!title || !url || !title_en || !rank || !photo) {
        return;
      }

      this.$store.commit(SET_LOADING, true);

      this.$store
        .dispatch(UPDATE_LINK, this.link)
        .then(() => {
          this.message.content = SUCCESS_MESSAGE;
          this.message.display = true;
          this.message.error = false;

          //On réinitialise l'état
          this.link = {
            title: "",
            url: "",
            title_en: "",
            rank: "",
            photo:""
          };
          this.submitted = false;
        })
        .catch((error) => {
          this.errors = error.errors;
          this.message.content = `${error} \n ${JSON.stringify(error.errors)}`;
          this.message.display = true;
          this.message.error = true;
          this.submitted = false;
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      //console.log(files);
      if (!files.length) return;

      this.getBase64(files[0])
        .then((data) => {
          this.link.photo = String(data);
          document.querySelector("#imageDisplay").src = data;
        })
        .catch(() => (this.link.photo = ""));
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.form-group {
  display: flex;
  align-items: center;
}
label {
  margin-bottom: unset !important;
}
</style>